import { getFormattedDate } from '@mantine/dates';
import { CashflowColumn } from './components/CashflowTable';
import { frequencyAmountCell } from './components/cashflowCells';
import { Expenditure } from './hooks/useExpenditures';
import { Income } from './hooks/useIncomes';
import { LifeEvent } from './hooks/useLifeEvents';
import { labelForIncomeType } from './incomeTypes';
import { Frequency, formatCurrency } from './utils';

export function incomeColumns(frequency: Frequency): CashflowColumn<Income>[] {
  const preTaxKey = frequency === 'monthly' ? 'amountPreTaxMonthly' : 'amountPreTaxAnnually';
  const postTaxKey = frequency === 'monthly' ? 'amountPostTaxMonthly' : 'amountPostTaxAnnually';

  return [
    {
      key: 'incomeType',
      header: 'Type',
      renderValue: value => labelForIncomeType(String(value)),
    },
    { key: 'description', header: 'Source' },
    { key: 'frequency', header: 'Frequency' },
    {
      key: preTaxKey,
      header: 'Before tax',
      renderValue: (_value, item) =>
        frequencyAmountCell(frequency, item.amountPreTaxMonthly, item.amountPreTaxAnnually, {
          positive: true,
        }),
    },
    {
      key: postTaxKey,
      header: 'After tax',
      renderValue: (_value, item) =>
        frequencyAmountCell(frequency, item.amountPostTaxMonthly, item.amountPostTaxAnnually, {
          positive: true,
        }),
    },
  ];
}

export function expenditureColumns(frequency: Frequency): CashflowColumn<Expenditure>[] {
  const amountKey = frequency === 'monthly' ? 'amountMonthly' : 'amountAnnually';

  return [
    { key: 'category', header: 'Category' },
    { key: 'frequency', header: 'Frequency' },
    {
      key: amountKey,
      header: `Spend (${frequency})`,
      renderValue: (_value, item) =>
        frequencyAmountCell(frequency, item.amountMonthly, item.amountAnnually),
    },
  ];
}

export const lifeEventColumns: CashflowColumn<LifeEvent>[] = [
  { key: 'description', header: 'Description' },
  {
    key: 'eventDate',
    header: 'Date',
    renderValue: value =>
      getFormattedDate({
        type: 'default',
        date: new Date(String(value)),
        locale: 'en',
        format: 'D MMMM YYYY',
        labelSeparator: '',
      }),
  },
  { key: 'details', header: 'Details' },
  {
    key: 'cost',
    header: 'Amount',
    renderValue: value => formatCurrency(Number(value)),
  },
];
